import React from "react";
import DemoPage from "@/components/DemoPage";

const DemoADADental = () => (
  <DemoPage
    seo={{
      title: "Demo: ADA J430D Dental Claim Extraction | See Hewto.ai in Action",
      description:
        "Watch Hewto.ai capture, validate, and structure data from an ADA J430D dental claim form in real time — tooth numbers, surfaces, CDT codes, and NPIs to a validated 837D. Book a personalized demo on your own dental claims.",
      keywords:
        "ada j430d demo, dental claim ocr demo, dental claim form ocr demo, j430d extraction demo, 837d demo, dental document ai demo",
      canonical: "https://www.hewto.ai/demo/ada-dental",
    }}
    heading="Demo"
    intro="See Hewto.ai automate ADA J430D dental claim extraction. Our AI captures tooth numbers, surfaces, CDT codes, and provider NPIs — validated and 837D-ready in seconds."
    videoId="RyGNVnLXM3E"
    videoTitle="Hewto.ai — Handwritten ADA J430D dental claim demo"
    source="demo_ada_j430d"
  />
);

export default DemoADADental;
